<template>
  <section id="aboutGrexy" class="about-grexy-section">
    <b-container class="about-grid">
      <b-row>
        <b-col class="col-xs-12" lg="6">
          <div class="about-content-left">
              <h3 class="title-box">{{$t('About Grexy')}}</h3>
              <p class="text-section">{{$t('about-text-1')}}</p>
            <div class="img-container">
              <img v-if="$i18n.locale === 'en'" class="main-photo" src="../assets/img/new-content/app-prev-eng.png" alt="About image">
              <img v-else-if="$i18n.locale === 'uk'" class="main-photo" src="../assets/img/new-content/app-prev-ua.png" alt="About image">
              <img v-else class="main-photo" src="../assets/img/new-content/app-prev-eng.png" alt="About image">

              <img class="benefits-bg-icon bg-icon-1" src="../assets/img/Shelter.svg" alt="Game avatar image">
              <img class="benefits-bg-icon bg-icon-2" src="../assets/img/Vet-clinic.svg" alt="Game avatar image">
            </div>
          </div>
        </b-col>
        <b-col class="col-xs-12" lg="6">
          <div class="about-content-right">
            <div class="img-container">
              <img class="section-image" src="../assets/img/new-content/about-dogs.png" alt="About image">
              <img class="benefits-bg-icon bg-icon-3" src="../assets/img/Cafe.svg" alt="Game avatar image">
              <img class="benefits-bg-icon bg-icon-4" src="../assets/img/Dog walk.svg" alt="Game avatar image">
              <img class="benefits-bg-icon bg-icon-5" src="../assets/img/Grooming.svg" alt="Game avatar image">
            </div>
           <div class="text-container">
             <p class="text-section">{{$t('about-text-2')}}</p>
           </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/sass/app.scss";

.about-grexy-section{
  padding:  40px 0 80px 0;
  background: #ffffff;
  overflow: hidden;
  p{
    margin: 0;
  }
  .about-content-left{
    display: flex;
    flex-direction: column;
    gap: 32px;
    padding-top: 90px;
    @media screen and (min-width: 320px) {
      padding-top: 40px;
      gap: 24px;
    }
    @media screen and (min-width: 374px) {
    }
    @media screen and (min-width: 425px) {
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (min-width: 992px) {
    }
    @media screen and (min-width: 1440px) {
      padding-top: 90px;
      gap: 32px;
    }
    @media screen and (min-width: 1920px) {
    }
    .img-container{
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 10px;
      position: relative;
      .main-photo{
        width: 100%;
        max-width: 443px;
        z-index: 2;
      }
      .benefits-bg-icon{
        position: absolute;
      }
      .bg-icon-1{
        width: 90px;
        height: 90px;
        left: -50%;
        @media screen and (min-width: 320px) {
          top: calc( 0px - 40px );
          left: calc(100% - 90px);
        }
        @media screen and (min-width: 374px) {
        }
        @media screen and (min-width: 425px) {
        }
        @media screen and (min-width: 768px) {
        }
        @media screen and (min-width: 992px) {
          width: 90px;
          height: 90px;
          left: -50%;
          top: unset;
        }
        @media screen and (min-width: 1440px) {
        }
        @media screen and (min-width: 1920px) {
        }
      }
      .bg-icon-2{
        left: -30%;
        width: 110px;
        height: 110px;
        bottom: 20px;
        transform: rotate(-15deg);
        @media screen and (min-width: 320px) {
          z-index: 1;
          width: 80px;
          height: 80px;
          left: 0;
          bottom: -30px;
        }
        @media screen and (min-width: 374px) {
        }
        @media screen and (min-width: 425px) {
        }
        @media screen and (min-width: 768px) {
        }
        @media screen and (min-width: 992px) {
          width: 110px;
          height: 110px;
          left: -30%;
          bottom: 20px;
          z-index: 3;
        }
        @media screen and (min-width: 1440px) {
        }
        @media screen and (min-width: 1920px) {
        }
      }
    }
  }
  .about-content-right{
    height: 100%;
    display: flex;
    flex-direction: column;
    @media screen and (min-width: 320px) {
      flex-direction: column-reverse;
    }
    @media screen and (min-width: 374px) {
    }
    @media screen and (min-width: 576px) {
    }
    @media screen and (min-width: 768px) {

    }
    @media screen and (min-width: 992px) {
      flex-direction: column;
    }
    @media screen and (min-width: 1440px) {

    }
    @media screen and (min-width: 1920px) {
    }
    .img-container{
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      .section-image{
        width: 100%;
        max-width: 466px;
      }
      .benefits-bg-icon{
        position: absolute;
      }
      .bg-icon-3{
        margin-top: 160px;
        margin-left: 75px;
        transform: rotate(8deg);
        @media screen and (min-width: 320px) {
          margin-top: 0;
          margin-left: 0;
          bottom: -60px;
          right: 0;
        }
        @media screen and (min-width: 374px) {
        }
        @media screen and (min-width: 425px) {
        }
        @media screen and (min-width: 768px) {
        }
        @media screen and (min-width: 992px) {
          margin-top: 160px;
          margin-left: 75px;
          bottom: unset;
          right: unset;
        }
        @media screen and (min-width: 1440px) {
        }
        @media screen and (min-width: 1920px) {
        }
      }
      .bg-icon-4{
        @media screen and (min-width: 320px) {
          bottom: -20px;
          left: -25px;
        }
        @media screen and (min-width: 374px) {
        }
        @media screen and (min-width: 425px) {
        }
        @media screen and (min-width: 768px) {
        }
        @media screen and (min-width: 992px) {
          bottom: unset;
          left: unset;
        }
        @media screen and (min-width: 1440px) {
        }
        @media screen and (min-width: 1920px) {
        }
      }
      .bg-icon-5{
        bottom: -95px;
        margin-right: 25px;
        @media screen and (min-width: 320px) {
          top: calc( 0px - 60px );
          right: 0;
          bottom: unset;
          margin-right: 0;
        }
        @media screen and (min-width: 374px) {
        }
        @media screen and (min-width: 425px) {
        }
        @media screen and (min-width: 768px) {
        }
        @media screen and (min-width: 992px) {
          top: unset;
          right: unset;
          bottom: -95px;
          margin-right: 25px;
        }
        @media screen and (min-width: 1440px) {
        }
        @media screen and (min-width: 1920px) {
        }
      }
    }
    .text-container {
      height: 100%;
      display: flex;
      align-items: center;
      @media screen and (min-width: 320px) {
        margin-top: 40px;
        margin-bottom: 40px;
      }
      @media screen and (min-width: 374px) {
      }
      @media screen and (min-width: 425px) {
      }
      @media screen and (min-width: 768px) {
      }
      @media screen and (min-width: 992px) {
        margin-top: 0;
        margin-bottom: 0;
      }
      @media screen and (min-width: 1440px) {
      }
      @media screen and (min-width: 1920px) {
      }
    }
  }
  .title-box{
    font-family: $main-font;
    font-size: 40px;
    font-weight: 700;
    line-height: 48px;
    text-align: left;
    margin: 0;
    color: #30394B;
    @media screen and (min-width: 320px) {
      font-size: 32px;
      font-weight: 700;
      line-height: 38.4px;
    }
    @media screen and (min-width: 374px) {
    }
    @media screen and (min-width: 425px) {
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (min-width: 992px) {
      font-size: 40px;
      font-weight: 700;
      line-height: 48px;
    }
    @media screen and (min-width: 1440px) {

    }
    @media screen and (min-width: 1920px) {
    }
  }
  .text-section{
    font-family: $main-font;
    font-size: 20px;
    font-weight: 300;
    line-height: 28px;
    text-align: left;
    color: #30394B;
    @media screen and (min-width: 320px) {
      font-size: 18px;
      font-weight: 300;
      line-height: 28px;
    }
    @media screen and (min-width: 374px) {
    }
    @media screen and (min-width: 425px) {
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (min-width: 992px) {
      font-size: 20px;
      font-weight: 300;
      line-height: 28px;
    }
    @media screen and (min-width: 1440px) {

    }
    @media screen and (min-width: 1920px) {
    }
  }
}
</style>
